module.exports = __webpack_public_path__ + "img/book-mall-cion.74b53396.png";